import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycProbateProceedingInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-probate-proceeding-in-new-york/']} />;
}
